var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"business-units"},[_c('h3',[_vm._v("Business Units")]),_c('div',{staticClass:"business-units-table",domProps:{"innerHTML":_vm._s(_vm.businessUnitsBreakdown)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }